import { Component, OnInit, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatIconModule } from "@angular/material/icon";
import { Store } from "@ngrx/store";

import { CommonModule } from "@angular/common";
import { TaxIdentificationNumberDetailsActions } from "@store/actions/tax-identification-number-details/tax-identification-number-details.actions";
import {
  selectTINInfo,
  selectTINDetailsData,
} from "@store/selectors/tax-identification-number-details/tax-identification-number-details.selectors";
import { ColDef, GridOptions, ValueFormatterParams } from "ag-grid-community";
import { AgGridAngular } from "ag-grid-angular";
import { MatDialog } from "@angular/material/dialog";
import { EditDeleteRendererComponent } from "../shared/edit-delete-renderer/edit-delete-renderer.component";
import { TinMaskRendererComponent } from "../shared/tin-mask-renderer/tin-mask-renderer.component";
import { myCustomTheme } from '../../constants/grid-themes';


@Component({
  selector: "app-tax-identification-number-details",
  imports: [
    FormsModule,
    MatInputModule,
    MatCardModule,
    CommonModule,
    AgGridAngular,
    MatSelectModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatIconModule,
  ],
  templateUrl: "./tax-identification-number-details.component.html",
  styleUrl: "./tax-identification-number-details.component.css",
})
export class TaxIdentificationNumberDetailsComponent implements OnInit {
  private readonly store = inject(Store);
  readonly dialog = inject(MatDialog);
  theme = myCustomTheme;
  private gridApi: any;
  private gridColumnApi: any;
  public gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 20,
    suppressClickEdit: true,
    editType: "fullRow",
    onGridReady: this.onGridReady.bind(this),
  };
  colDefs: ColDef[] = [];
  defaultColDef: ColDef = {
    flex: 1,
    filter: true,
    editable: false,
  };

  contactDetailsInfo$ = this.store.select(selectTINInfo);
  dataSource$ = this.store.select(selectTINDetailsData);

  ngOnInit() {
    this.store.dispatch(
      TaxIdentificationNumberDetailsActions.componentTINDetailsLoaded()
    );
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.setColDefs();
  }

  setColDefs() {
    this.colDefs = [
      {
        field: "name",
        headerName: "Name",
        tooltipField: "name"
      },
      {
        field: "tin",
        headerName: "Tax ID",
        cellRenderer: TinMaskRendererComponent,
      },
      {
        field: "effectiveDate",
        headerName: "Effective Date",
        valueFormatter: (params: ValueFormatterParams) => this.formatDateValue(params.value),
      },
      {
        field: "expirationDate",
        headerName: "Expiration Date",
        valueFormatter: (params: ValueFormatterParams) => this.formatDateValue(params.value),
      },
      {
        field: "actions",
        maxWidth: 150,
        width: 50,
        filter: false,
        editable: false,
        suppressNavigable: true,
        cellRenderer: EditDeleteRendererComponent,
        cellRendererParams: {
          showDelete: true,
          showEdit: true
      }
      },
    ];
  }

  private formatDateValue(value: string | null | undefined): string {
    if (!value) return '';
    const [year, month, day] = value.split('T')[0].split('-').map(Number);
    return new Date(year, month - 1, day).toLocaleDateString();
  }

  addTINButtonPressed() {
    this.store.dispatch(
      TaxIdentificationNumberDetailsActions.openAddTinPressed()
    );
  }

  onCellClicked(params: any) {
        if (
          params.column.colId === "actions" &&
          params.event.target.dataset.action
        ) {
          let action = params.event.target.dataset.action;
          if (action === "edit") {
            this.store.dispatch(TaxIdentificationNumberDetailsActions.openEditTinPressed({tin: params.data}))
            
          } else if (action === "delete") {
            this.store.dispatch(TaxIdentificationNumberDetailsActions.openDeleteTinPressed({name: params.data.name, id: params.data.id}))
          }
        }
  }
}
